var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('h2',{staticStyle:{"padding-top":"3rem"}},[_vm._v("好用点点")]),_c('button',{staticClass:"btn green",attrs:{"type":"primary"},on:{"click":function($event){return _vm.handLogin()}}},[_vm._v(" 微信授权登录 ")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }